import React from 'react'

const ShiftAssinmentModal = () => {
  return (
    <div>ShiftAssinmentModal</div>
  )
}

export default ShiftAssinmentModal